// import React, { lazy } from "react";
// import { Route } from "react-router-dom";

// const Login = lazy(() => import("./Components/Login/login"));
// const ForgotPassword = lazy(() => import("./Components/Login/forgotPassword"));
// const VerifyEmail = lazy(() => import("./Components/Login/verifyEmail"));
// const SetPassword = lazy(() => import("./Components/Login/setPassword"));

// export default function AuthPages({ setCurrentPage, currentPage }) {
// console.log(currentPage, "currentpage");
// const [page, setpage] = React.useState("login");


// const renderPage = () => {
//     switch (page) {
//       case "login":
//         return <Login setpage={setpage} />;
//       case "resetPassword":
//         return <ForgotPassword setpage={setpage} />;
//       case "verifyEmail":
//         return <VerifyEmail setpage={setpage} />;
//       case "setPassword":
//         return <SetPassword setpage={setpage} />;
//       default:
//         return <Login setpage={setpage} />;
//     }
//   };



// console.log(page);
//   return (
//     <>
//       <Route path="/" element={<Login setCurrentPage={setpage} />} />
//       <Route path="/" element={<ForgotPassword setCurrentPage={setpage} />} />
//       <Route path="/" element={<VerifyEmail setCurrentPage={setpage} />} />
//       <Route path="/" element={<SetPassword setCurrentPage={setpage} />} />
//     </>
//   );
// }

import React, { lazy, useState } from "react";

const Login = lazy(() => import("./Components/Login/login"));
const ForgotPassword = lazy(() => import("./Components/Login/forgotPassword"));
const VerifyEmail = lazy(() => import("./Components/Login/verifyEmail"));
const SetPassword = lazy(() => import("./Components/Login/setPassword"));

export default function AuthPages() {
  // console.log(currentPage, "currentpage");
  const [currentPage, setCurrentPage] = useState("login");

  const renderPage = () => {
    switch (currentPage) {
      case "login":
        return <Login setCurrentPage={setCurrentPage} />;
      case "resetPassword":
        return <ForgotPassword setCurrentPage={setCurrentPage} />;
      case "verifyEmail":
        return <VerifyEmail setCurrentPage={setCurrentPage} />;
      case "setPassword":
        return <SetPassword setCurrentPage={setCurrentPage} />;
      default:
        return <Login setCurrentPage={setCurrentPage} />;
    }
  };

  console.log(currentPage);

  return <>{renderPage()}</>;
}
